import {
  Locale,
  MemberSettingAuthMode,
  MemberSettingDownloadBannerAction,
  MemberSettingFundingMode,
  MemberSettingNameMode,
  MemberSettingPlayerNameCollectionMode,
  MemberUniqueInfoCollection,
} from "kz-ui-sdk";
import { Currency, CurrencyDirection } from "./configs";

/**
 * TODO: Move to kz-ui-sdk when BE confirmed
 * Place with _ prefix to mark will be removed
 */
export enum _MemberSettingOnboardDialogLayout {
  // Popup dialog with onboarding drawer
  DIALOG_DRAWER = "dialog-drawer",
  // Popup dialog with onboarding screen
  DIALOG_PAGE = "dialog-page",
}

/**
 * Member settings:
 * MP use member settings to configure the app UI/UX
 * UI/UX can be configured from server:
 */
export interface MemberSettings {
  /**
   * Determines the theme of the app
   * /info.theme.color
   */
  themeId: string;
  /**
   * Determines the phone prefix of the app
   * /info.phoneSpec.phonePrefix
   */
  phonePrefix: string;
  /**
   * Determines the phone min length of the app
   * /info.phoneSpec.lengthRange
   */
  phoneMinLength: number;
  phoneMaxLength: number;
  /**
   * Determines the phone start with of the app
   */
  phoneStartWith: string[];
  /**
   * Simplify phone error message (use generic length-only message)
   */
  phoneSimpleError?: boolean;
  /**
   * Determines the phone length of the app
   * /info.phoneSpec.lengths
   */
  phoneLengths: number[];
  /**
   * Determines the currency of the app
   * /info.currency
   */

  currency: Currency | string;
  /**
   * Determines the currency direction of the app
   * Direction from {@link CURRENCY_CONFIGS}
   */
  currencyDirection: CurrencyDirection;
  /**
   * Determines the currency symbol of the app
   * Symbol from {@link CURRENCY_CONFIGS}
   */
  currencySymbol: string;
  /**
   * Determines the language of the app
   * /info.languageCode
   */
  language: string;
  /**
   * @deprecated Use locales instead
   * /info.languageList
   */
  languageList?: string[];
  /**
   * @deprecated Use feature flags instead
   * /info.countryCode
   */
  countryCode: string;
  // feature flags
  authMode: MemberSettingAuthMode | null;
  fundingMode: MemberSettingFundingMode;
  nameMode: MemberSettingNameMode | null;
  onboardDialogLayout: _MemberSettingOnboardDialogLayout;
  depositMode: "group" | "individual" | null;
  otpType: "SMS" | "Email" | "WhatsApp";
  googleAuthEnabled: boolean;
  isSupportAuthSocial?: boolean;

  nameCollectionMode: MemberSettingPlayerNameCollectionMode;
  /**
   * Determines if the member settings are loaded
   * Should only render app after member settings are loaded
   */
  isLoaded: boolean;

  downloadBanner?: {
    action?: MemberSettingDownloadBannerAction;
    externalUrl?: string;
  };

  /**
   * Determines the locale list of the app
   * /info.locales
   */
  locales?: Locale[];

  /**
   * Determines the if phone input prefix should be shown
   */
  showPhoneInputPrefix?: boolean;

  /**
   * Determines the player info collections of the app
   */
  playerInfoCollections?: MemberUniqueInfoCollection[];
}

/**
 * Theme portal config
 * These configs are used to configure the theme in MP only
 * Whereas ThemeColorConfig is used to configure the theme in SDK
 *
 */
export interface ThemePortalConfig {
  metaThemeColor: string;
  extendedCss: string;
  className: string;
  id: string;
}

export enum PostLoginInfoType {
  BANK_ACCOUNT = "bankAccount",
  LEGAL_NAME = "legalName",
  BANK_LEGAL_NAME = "bankLegalName",
}
